import "./MethodologyFooter.css";

// Static text, ported verbatim from dashboard.html line 298. Not per-tab -
// this stays the same regardless of which chart (Range bars / Distribution)
// is active, so it's rendered once in App.js, outside the tab switch.
export default function MethodologyFooter() {
  return (
    <footer className="mf-footer">
      <div className="mf-row">
        <div className="mf-method">
          <strong>Methodology.</strong> Fully loaded cost includes base salary, employer
          statutory contributions (national insurance, pension, social security), mandatory
          benefits, and an allocated share of indirect employer costs per territory. Tier
          definitions (NTR: new to role, Exp: experienced, Vexp: very experienced) map to
          stated percentiles within each territory's incumbent population (typically
          P10/P40/P50/P60/P90; South Africa uses a shifted P10/P30/P40/P50/P90 schema).
          Distribution curves in view 02 are Gaussian fits derived by least-squares regression
          of each territory's five percentile points, so the peak (μ) represents the typical
          incumbent rather than a guessed midpoint. Territories whose bands are derived
          synthetically from approved business rules, with no incumbent data, are shown as a
          dashed range bar instead of a fitted curve; no statistical distribution is inferred
          for these.
        </div>
      </div>
    </footer>
  );
}
